import {
  Component,
  OnInit,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../core/services/toastNotif.service';
import {
  RegisterUserPayload,
  RegisterUserResponse,
  ConfirmRegisterUserPayload,
  ConfirmRegisterUserResponse,
} from '../../../core/models/user.model';
import { ToastrService } from 'ngx-toastr';
import { ToastCustomService } from '../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiLineLiffService } from '../../../core/services/api/Line-liff/api-line-liff';

@Component({
  selector: 'app-verify-otp',
  imports: [CommonModule, FormsModule],
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.css',
})
export class VerifyOtpComponent implements OnInit {
  phone: string = '';
  refNo: string = '';
  otpValues: string[] = Array(6).fill(''); // ช่อง OTP 6 หลัก
  array: number[] = [1, 2, 3, 4, 5, 6];
  loading: boolean = false;
  isButton: boolean = false;
  error: string = '';
  token: string = '';
  pinCode: string = '';
  countdown: number = 0;
  canResend: boolean = true;
  interval: any;
  isConfiorm: boolean = false;
  codeInvite: string = '';
  uid: string = '';
  display_name: string = '';
  language: string = 'TH';
  pictureUrl: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiLineLiffService: ApiLineLiffService,
    private toastr: ToastrService,
    private cookie: CookieService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService
  ) { }

  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  // เริ่มทำงานหลังจาก โหลดหน้านี้
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.phone = params['phone'] || '';
      this.codeInvite = params['invite'] || '';
      console.log('codeInvite:', this.codeInvite);
      // console.log('userid:', this.cookie.get('line_uid'));
      this.uid =
        this.cookie.get('line_uid')?.trim() ||
        localStorage.getItem('line_uid') ||
        '';

      this.pictureUrl =
        this.cookie.get('pictureUrl')?.trim() ||
        localStorage.getItem('pictureUrl') ||
        '';

      this.display_name =
        this.cookie.get('display_name')?.trim() ||
        localStorage.getItem('display_name') ||
        '';

      this.language =
        this.cookie.get('language')?.trim() ||
        localStorage.getItem('language') ||
        '';

      if (this.uid) {
        setTimeout(() => {
          this.RequestOtp('1');
        }, 300);
      } else {
        this.showError('คุณยังไม่ได้ Login LINE !');
        this.router.navigate(['/register']);
      }
    });
  }

  /* -------------------------------------- Function -------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.showerror(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.showsuccess(text);
    this.toastCustomService.showSuccess('', text)
  }
  /* --- Function --- */
  ConfirmOtp() {
    this.isConfiorm = true;
    const payload: ConfirmRegisterUserPayload = {
      uid:
        this.cookie.get('line_uid') ||
        localStorage.getItem('line_uid') ||
        '',
      phone_number: this.phone,
      ref_no: this.refNo,
      pin_code: this.pinCode,
    };

    this.apiLineLiffService.confirmOTP(payload).subscribe({
      next: (res: ConfirmRegisterUserResponse) => {
        const code = res.code;
        if (code == '000') {
          this.showSuccess('ลงทะเบียนเรียบร้อย !');
          this.isConfiorm = false;
          this.cookie.set('login_status', 'logged_in');
          localStorage.setItem('login_status', 'logged_in');
          this.cookie.delete('token_user');
          localStorage.removeItem('token_user');
          setTimeout(() => {
            this.router.navigate(['/vehicle-setting']);
          }, 1000);
        } else {
          this.isConfiorm = false;
          this.showError('การลงทะเบียนไม่สำเร็จ OTP ไม่ถูกต้อง');
        }
      },
      error: (err) => {
        console.error('Confirm OTP failed:', err);
        this.showError('การลงทะเบียนไม่สำเร็จ OTP ไม่ถูกต้อง');
        this.loading = false;
        this.isConfiorm = false;
      },
    });
  }

  RequestOtp(status: string) {
    this.loading = true;
    const payload: RegisterUserPayload = {
      uid: this.uid,
      full_name: this.display_name,
      phone: this.phone,
      email: '',
      referral_code: '',
      inviteCode: this.codeInvite.trim(),
      language: this.language,
      pictureUrl: this.pictureUrl
    };

    this.apiLineLiffService.reqeustOTP(payload).subscribe({
      next: (res: RegisterUserResponse) => {
        if (res.code !== '000') {
          console.error('Request OTP business fail:', res);
          this.showError(res.message || 'ส่ง OTP ไม่สำเร็จ');
          this.loading = false;
          return;
        }
        this.refNo = res.ref_no || res.request_no || '';
        if (status == '2') {
          this.interval = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              this.canResend = true;
              clearInterval(this.interval);
            }
          }, 1000);
        }
      },
      error: (err) => {
        console.error('Request OTP failed:', err);
        console.error('[Register] 400 validation errors:', err?.error?.errors ?? err?.error);
        this.showError('ส่ง OTP ไม่สำเร็จ');
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  // getToken(): void {
  //   this.loading = true;

  //   this.tokenService.getToken('LINE OA').subscribe({
  //     next: (token) => {
  //       this.token = token;
  //       console.log('✅ Token ที่ได้:', token);
  //       // 🔜 คุณสามารถเรียก verifyOtp(token) ต่อได้ที่นี่
  //     },
  //     error: (err) => {
  //       console.error('❌ ขอ token ไม่สำเร็จ:', err);
  //     },
  //     complete: () => {
  //       this.loading = false;
  //     },
  //   });
  // }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // รับแค่ตัวสุดท้าย (กัน paste หรือพิมพ์ไว)
    if (value.length > 1) {
      value = value.charAt(value.length - 1);
      input.value = value;
    }

    if (!/^[0-9]$/.test(value)) {
      input.value = '';
      this.otpValues[index] = '';
      return;
    }

    this.otpValues[index] = value;

    // ✅ ไม่ต้อง set input.value = value อีกครั้ง
    // เพราะ [value] จะ update เอง

    // ✅ focus ช่องถัดไป
    if (value && index < this.otpValues.length - 1) {
      const next = this.otpInputs.toArray()[index + 1];
      next.nativeElement.focus();
    }

    // ✅ เมื่อครบ 6 หลัก
    const fullOtp = this.otpValues.join('');

    if (this.otpValues.every((d) => d !== '')) {
      console.log('OTP ครบ:', fullOtp);
      this.pinCode = fullOtp;
      this.ConfirmOtp();
      this.isButton = true;
    } else {
      // console.log('OTP ไม่ครบ');
      this.isButton = false;
    }
  }

  onPaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData?.getData('text') ?? '';
    const digits = pasteData.replace(/\D/g, '').slice(0, 6).split('');

    if (digits.length === 6) {
      this.otpValues = digits;
      event.preventDefault();
      this.ConfirmOtp();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    // กด Backspace และช่องปัจจุบันว่าง
    if (event.key === 'Backspace' && input.value === '' && index > 0) {
      const prevInput = this.otpInputs.toArray()[index - 1];
      prevInput.nativeElement.focus();
    }

    // 👉 ถ้าอยากลบค่าด้วย:
    if (event.key === 'Backspace') {
      this.otpValues[index] = '';
    }

    const fullOtp = this.otpValues.join('');
    if (this.otpValues.every((d) => d !== '')) {
      console.log('OTP ครบ:', fullOtp);
      this.pinCode = fullOtp;
      this.ConfirmOtp();
      this.isButton = true;
    } else {
      // console.log('OTP ไม่ครบ');
      this.isButton = false;
    }
  }

  reSendRegister() {
    if (!this.canResend) return;
    this.canResend = false;
    this.countdown = 60;
    setTimeout(() => {
      console.log('OTP ถูกส่ง!');
      this.loading = false;
      this.RequestOtp('2');
    }, 0);
  }

  sendRegister() {
    this.loading = true;

    // ตัวอย่างจำลอง async
    setTimeout(() => {
      console.log('OTP ถูกส่ง!');
      this.loading = false;
      this.RequestOtp('1');
    }, 0);
  }

  handleClick() {
    console.log('📞 โทรศัพท์ยืนยันแล้ว:', this.phone);
    // this.toastr.clear();
    // this.toastr.success(`สำเร็จแล้ว ✅ `, 'เยี่ยม!');
    this.ConfirmOtp();
  }

  backClick() {
    this.router.navigate(['/register']);
  }
}
